<template>
    <div class="container flex flex-direction">
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <a :href="`/digitize/all${xiangmu_id ? `?xiangmu_id=${xiangmu_id}` : ''}`" style="position: fixed;top: 20px;left: 20px;width: 150px;height: 40px;text-align: center;line-height: 40px;background: rgba(255,255,255,.2);color: #fff;font-size: 20px;border-radius: 10px;">返回</a>
        <div class="page-title self-center">首华·双暖为老志愿服务队员发展数据</div>
        <div class="flex-sub flex justify-center margin-top-xl ">
            <div class="flex-sub flex flex-direction">
                <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent" class="title-container flex-sub">
                    <div class=" flex flex-direction padding-lr">
                        <!--            -->
                        <div class="title margin-top">队员总数{{ wuye_num + jumin_num }}名</div>
                        <div class="flex margin-top-sm">
                            <div class="total-container flex-sub flex flex-direction align-center justify-center">
                                <div class="label">物业队员</div>
                                <!--                -->
                                <div class="total margin-tb-sm">{{ wuye_num }}名</div>
                                <div class="info">占比：{{ wuye_lv.toFixed(2) }}%</div>
                            </div>
                            <div class="total-container flex-sub flex flex-direction align-center justify-center margin-left-sm">
                                <div class="label">居民队员</div>
                                <!--                jumin_num-->
                                <div class="total margin-tb-sm">{{ jumin_num }}名</div>
                                <div class="info">占比：{{ jumin_lv.toFixed(2) }}%</div>
                            </div>
                        </div>
                        <div class="total-container member flex align-center justify-around margin-top-sm">
                            <img class="icon self-end" src="../../../assets/img/data/icon_team_development_party.png">
                            <div class="flex flex-direction align-center justify-center ">
                                <div class="label">党员</div>
                                <div class="total margin-tb-sm">{{ dangyuan_num }}名</div>
                                <div class="info">占比：{{ dangyuan_lv }}%</div>
                            </div>
                        </div>
                    </div>
                </dv-border-box-10>
                <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent"
                                  class="title-container flex-sub margin-top-sm">
                    <div class="bg-title">
                        <div class="title">构 成</div>
                    </div>
                    <div id="line-echarts" class="echarts padding-top-xl padding-lr-sm padding-bottom-sm"></div>
                </dv-border-box-10>
            </div>
            <div class="flex-sub flex flex-direction margin-lr-sm">
                <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent" class="title-container flex-sub">
                    <div class="bg-title">
                        <div class="title">性 别</div>
                    </div>
                    <div id="sex_echarts" class="echarts"></div>
                </dv-border-box-10>
                <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent"
                                  class="title-container flex-sub margin-top-sm">
                    <div class="bg-title">
                        <div class="title">年 龄</div>
                    </div>
                    <div id="up_echarts" class="echarts padding-sm"></div>
                </dv-border-box-10>
            </div>
            <div class="flex-sub flex flex-direction">
                <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent" class="title-container flex-sub">
                    <div class="bg-title">
                        <div class="title">队 员</div>
                    </div>
                    <div class="red flex flex-direction padding" style="height: 500px">
                        <el-input class="margin-top" v-model="search_content" placeholder="请输入">
                            <i slot="suffix" class="el-input__icon el-icon-search cursor" @click="init"></i>
                        </el-input>
                        <el-table
                            class="flex-sub margin-top-xs"
                            v-loading="loading"
                            :data="lists"
                            header-row-class-name="table-header"
                            border
                            height="206"
                            style="width: 100%">
                            <el-table-column label="序号" prop="title" width="80">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        {{ scope.$index + 1 }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="姓名" prop="name" width="120">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        {{ scope.row.name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="队员类型" prop="power" width="120">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        {{ scope.row.power === 6 || Number(scope.row.tags) === 2 ? '物业员工' : '居民队员' }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="所属小区" prop="xiaoqu_name">
                                <template slot-scope="scope">
                                    <div class="table-item">
                                        {{ scope.row.xiaoqu_name }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </dv-border-box-10>
                <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent"
                                  class="title-container flex-sub margin-top-sm">
                    <div class="bg-title">
                        <div class="title">队 长</div>
                    </div>
                    <div class="padding-sm flex align-center" style="padding-top: 50px">
                        <div class="swiper-button-prev"></div>
                        <swiper
                            ref="swiper"
                            style="width: 525px;"
                            class="margin-top-xl"
                            navigation
                            :pagination="{ clickable: true }"
                            :options="swiperOption">
                            <swiper-slide v-for="(item,index) in duizhang_list" :key="index">
                                <div class="member-item flex flex-direction align-center">
                                    <img v-if="item.avatar" class="image" :src="upUrl + item.avatar"/>
                                    <img v-else class="image" src="../../../assets/img/sn-logo.png"/>
                                    <div class="name margin-tb-xs">{{ item.name }}</div>
                                    <div class="info ovHide padding-lr-xs">{{ item.team_name }}</div>
                                    <div class="info ovHide padding-lr-xs">{{ item.xiaoqu_name }}</div>
                                </div>
                            </swiper-slide>
                        </swiper>

                        <div class="swiper-button-next"></div>
                    </div>
                </dv-border-box-10>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import {serviceTeamMemberData} from "@/api/weilao";
import {upFeil} from "@/config";

export default {
    name: "team_development",
    components: {Swiper, SwiperSlide},
    data() {
        return {
            xiangmu_id:'',
            upUrl: upFeil + '/',
            wuye_num: 0,
            wuye_lv: 0,
            jumin_num: 0,
            jumin_lv: 0,
            dangyuan_num: 0,
            dangyuan_lv: 0,


            search_content: '',
            lists: [],
            duizhang_list: [],
            loading: false,
            line_echarts: '',
            sex_option: {
                animationDuration: 2000,
                animationEasing: 'cubicOut',
                color: ["#38e6e5", "#ffc919", '#0a2240'],
                tooltip: {},
                legend: {
                    show: false,
                    icon: 'rect',
                    itemWidth: 14,
                    itemHeight: 5,
                    itemGap: 6,
                    right: '30px',
                    top: '70px',
                    textStyle: {
                        fontSize: 10,
                        color: '#fff'
                    },
                    data: []
                },
                grid: {
                    left: '0%',
                    right: '0%',
                    bottom: '0%',
                    containLabel: true
                },

                series: {
                    data: [],
                    type: 'pie',
                    label: {
                        formatter: '{b}:\n {@2012}人 \n({d}%)'
                    },
                    radius: ['30%', '45%'],
                }
            },
            option: {
                animationDuration: 2000,
                animationEasing: 'cubicOut',
                color: ['#ee6f42', '#eba041', '#dc3838', '#41cc89'],
                textStyle: {
                    color: '#ffffff',
                },
                grid: {
                    left: '0%',
                    right: '0%',
                    bottom: '0%',
                    containLabel: true
                },
                xAxis: {
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                            width: 5,
                        }
                    },
                    type: 'category',
                    axisLabel: {
                        fontSize: 10
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: true, //去除刻度线
                        lineStyle: {
                            color: '#fff',
                            type: 'dotted',
                            dashOffset: 2
                        }
                    },
                    axisTick: {
                        show: false //去除刻度线
                    },
                    axisLine: {
                        show: false, //去除轴线
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                },
                series: {
                    data: [],
                    type: 'bar',
                    barWidth: '30%',
                    label: {
                        show: false,
                        position: 'top',
                        valueAnimation: true
                    },
                    itemStyle: {
                        normal: {
                            label: {
                                formatter: "{c}" + "人",
                                show: true,
                                position: "top",
                                textStyle: {
                                    fontWeight: "bolder",
                                    fontSize: "12",
                                    color: "#fff"
                                }
                            },
                        }
                    }
                }
            },
            up_option: {
                animationDuration: 2000,
                animationEasing: 'cubicOut',
                color: ["#38e6e5", "#ffc919",],
                tooltip: {
                    trigger: 'axis',
                    formatter: function (c) {
                        let str = '';
                        let temp = {
                            bgcricle: '',//颜色
                            seriesName: "", //name
                            valueData: '',//value
                            spacespan: '',
                        };
                        c.forEach((item) => {
                            // 做的事情
                            temp.bgcricle = item.marker;
                            temp.seriesName = item.name;
                            temp.valueData = item.value + "%";
                            temp.spacespan = '<span style="display:inline-block;margin: 0 4px;">:</span>';
                            str += temp.bgcricle + temp.seriesName + temp.spacespan + temp.valueData + '<br />'
                        })
                        return str
                    }
                },
                legend: {
                    icon: 'rect',
                    itemWidth: 20,
                    itemHeight: 5,
                    itemGap: 15,
                    right: '0px',
                    top: '20px',
                    textStyle: {
                        fontSize: 12,
                        color: '#fff'
                    },
                },
                grid: {
                    left: '10px',
                    right: '20px',
                    bottom: '0%',
                    containLabel: true
                },
                xAxis: {
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                            width: 5,
                        }
                    },
                    type: 'category',
                    axisLabel: {
                        fontSize: 10
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    splitLine: {
                        show: true, //去除刻度线
                        lineStyle: {
                            color: '#fff',
                            type: 'dotted',
                            dashOffset: 2
                        }
                    },
                    axisTick: {
                        show: false //去除刻度线
                    },
                    axisLine: {
                        show: false, //去除轴线
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                },
                series: []
            },
            swiperOption: {
                // direction: 'vertical',
                slidesPerView: 3,
                loop: true,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                }
            }
        }
    },
    mounted() {
        this.xiangmu_id = this.$route.query.xiangmu_id
        this.init()
    },
    methods: {
        async init() {
            let sex_echarts = echarts.init(document.getElementById('sex_echarts'))
            const res = await serviceTeamMemberData(this.search_content,this.xiangmu_id)
            this.wuye_num = res.data.wuye_num
            this.wuye_lv = res.data.wuye_lv
            this.jumin_num = res.data.jumin_num
            this.jumin_lv = res.data.jumin_lv


            this.dangyuan_num = res.data.dangyuan_num
            this.dangyuan_lv = res.data.dangyuan_lv
            this.lists = res.data.member_list
            this.duizhang_list = res.data.duizhang_list

            let _typ = [], _typeNum = []
            res.data.goucheng_arr.map(item => {
                _typ.push(item.name)
                _typeNum.push(item.num)
            })

            let _age = [], _ageNum = [], _ageNum2 = []
            res.data.age_arr.map(item => {
                _age.push(item.name)
                _ageNum.push(item.wuye_num)
                _ageNum2.push(item.jumin_num)
            })


            this.sex_option.legend.data = ['男', '女']
            this.sex_option.series.data = [{name: "男", value: res.data.nan_num},
                {name: "女", value: res.data.nv_num},

            ]

            //{name: "未填写", value: (res.data.totle_num - (res.data.nan_num + res.data.nv_num))}
            sex_echarts.setOption(this.sex_option)
            this.line_echarts = echarts.init(document.getElementById('line-echarts'))
            let _data = {
                number: _typeNum,
                name: _typ
            }
            _data.number = _data.number.map((item, index) => {
                return {
                    value: item,
                    itemStyle: {
                        color: this.option.color[index]
                    }
                }
            })
            this.option.xAxis.data = _data.name
            this.option.series.data = _data.number
            this.line_echarts.setOption(this.option)
            let up_echarts = echarts.init(document.getElementById('up_echarts'))
            this.up_option.xAxis.data = _age
            let data = [{name: "物业队员", data: _ageNum}, {name: "居民队员", data: _ageNum2}]
            data.map(item => {
                item.type = 'line'
            })
            this.up_option.series = data
            up_echarts.setOption(this.up_option)
        }

    }
}
</script>

<style lang="scss" scoped>
.container {
    background: url(../../../assets/img/data/bg_data.jpg) no-repeat top;
    background-size: 100% 100%;
    height: 1080px;
    width: 1920px;
    overflow: hidden;
    padding: 0 35px 30px;

    .loading {
        color: #ffffff;
        position: fixed;
    }

    .page-title {
        font-size: 36px;
        line-height: 36px;
        color: transparent;
        -webkit-background-clip: text;
        background-image: linear-gradient(0deg,
            #ffd800 0%,
            #ffec83 50%,
            #ffffff 100%);
        background-blend-mode: normal, normal;
        margin-top: 25px;
        font-weight: bold;
    }

    .total-container {
        height: 148px;
        background-image: linear-gradient(270deg,
            #c83e09 10%,
            #e57d1c 50%,
            #e57d1c 100%);
        border: solid 1px #e57a1b;

        &.member {
            background-image: linear-gradient(0deg,
                #c83e09 0%,
                #e57d1c 100%);
        }

        .icon {
            height: 128px;
        }

        .label {
            font-size: 18px;
            color: #ffffff;
        }

        .total {
            font-size: 30px;
            font-weight: bold;
            color: #ffffff;
        }

        .info {
            min-width: 144px;
            padding: 0 12px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #97371766;
            border-radius: 15px;
            font-size: 18px;
            color: #ffffff;
        }
    }

    .title-container {
        .border-box-content {
            position: relative;
        }

        .years {
            position: absolute;
            right: 20px;
            top: 50px;
            width: 96px;
            height: 26px;
            line-height: 26px;
            border-radius: 15px;
            border: solid 1px #ffffff;
            text-align: center;
            color: #FFFFFF;
        }

        .bg-title {
            z-index: 99;
            width: 556px;
            text-align: center;
            height: 44px;
            line-height: 44px;
            position: absolute;
            background: url(../../../assets/img/data/bg_title.png) no-repeat top;
            background-size: 100% auto;
            left: 50%;
            transform: translateX(-50%);

        }

        .title {
            line-height: 44px;
            font-size: 24px;
            text-align: center;
            color: transparent;
            -webkit-background-clip: text;
            background-image: linear-gradient(0deg,
                #ffd800 0%,
                #ffec83 50%,
                #ffffff 100%);
            background-blend-mode: normal, normal;
            font-weight: bold;
        }
    }

    .member-item {
        width: 161px;
        height: 265px;
        background-color: #cb440a;
        box-shadow: 0px 9px 24px 0px rgba(0, 11, 45, 0.3);

        .image {
            width: 100%;
            height: 168px;
        }

        .name {
            font-size: 16px;
            color: #ffc91b;
        }

        .info {
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            width: 100%;
        }
    }

    .echarts {
        width: 100%;
        height: 100%;
        background: transparent;
    }

    .map {
        background: url(../../../assets/img/data/bg_map.png) no-repeat top;
        background-size: 100% 100%;
    }

    .dv-border-box-10 {
        background: #b73d0f;
        box-shadow: #fa9d1b55 0px 0px 0px 1px inset !important;
    }

    .swiper-button-prev:after, .swiper-button-next:after {
        color: #fff;
        font-size: 16px;
        width: 13px;
        height: 29px;
        line-height: 29px;
        text-align: center;
        background-color: #d7570e;
    }
}
</style>
